module.exports = __webpack_public_path__ + "media/assets/icons/comment-ede3381e4f89ffa68f3f23b0998964ef.svg";